import { createSvgComponent } from "../../icon/createSvgComponent";
import Blog from "@core/__generated__/icon/figma/blog.svg";
export default createSvgComponent(Blog);